export const ListQueryKey = 'shenbaoRecords';
export const DetailQueryKey = 'shenbaoRecord';
export const Urls = {
  selectUrl: '/declarationRecord/list',
  updateUrl: '/declarationRecord/update',
  deleteUrl: '/declarationRecord/delete',
  createUrl: '/declarationRecord/create',
  detailUrl: '/declarationRecord/detail'
};